<template>
  <div>
    <div class="app-card-header primary-actions">
      <div class="heading-block">
        <h4 class="heading">{{ chartOptions.title }}</h4>
      </div>
      <div class="actions-block">
        <!--Download Excel-->
        <v-tooltip top max-width="235px" :content-class="[`${getThemeColor === '0' ? 'dark-tooltip' : ''} +  i-tooltip`]">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                color="primary"
                flat
                small
                :ripple="false"
                @click="downloadHandler()"
              >
                <v-icon>icon-icon</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Download Excel</span>
        </v-tooltip>
      </div>
    </div>
    <div class="card-body pa-0">
      <v-progress-circular
        v-if="chartOptions.chartOptions.status.loading && !chartOptions.series.length"
        :indeterminate="true"
        :size="75"
        height="3"
        color="primary"
        class="progress-circular" />
      <v-progress-linear
        v-if="chartOptions.chartOptions.status.loading && chartOptions.series.length"
        :indeterminate="true"
        height="3"
        color="primary"
        class="progress-card" />
      <apexchart
        v-if="(!chartOptions.chartOptions.status.noData && !chartOptions.chartOptions.status.loading && chartOptions.series.length > 0) || (!chartOptions.chartOptions.status.noData && chartOptions.chartOptions.status.loading && chartOptions.series.length > 0)"
        ref="chart"
        type=line
        height=350
        :options="chartOptions.chartOptions"
        :series="chartOptions.series" />
      <i-no-data v-if="chartOptions.chartOptions.status.noData && !chartOptions.chartOptions.status.loading" heading="Oops!" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Chart',
  props: {
    chartOptions: {
      type: [Object, Array],
      default: null
    }
  },
  mounted () {
    if (this.chartOptions.series.length <= 0) {
      this.requestChart()
    }
  },
  methods: {
    requestChart () {
      this.$store.dispatch('analyticsAverageDeviationModule/getChart', {
        sellers: [],
        categories: [],
        brands: [],
        elementRef: this.$refs.chart
      })
    },
    copyChart () {
      return JSON.parse(JSON.stringify(this.chartOptions))
    },
    downloadHandler () {
      this.$emit('downloadExcel')
    }
  },
  computed: {
    chart () {
      return this.$store.state.analyticsAverageDeviationModule
    },
    getThemeColor () {
      return this.$store.state.auth.userInfo.themeColor
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/analytics/average-deviation/Chart.vue